// extracted by mini-css-extract-plugin
module.exports = {"jcError100":"#f9d1d4","jcWhite50":"#ffffff","errorCard":"Error__errorCard"};